module.exports = __webpack_public_path__ + "img/VillaLoreto_Gym.7acda8eb.jpg";